import { render } from "./BloodPanelSelectedTests.vue?vue&type=template&id=bcc2735c"
import script from "./BloodPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./BloodPanelSelectedTests.vue?vue&type=script&lang=js"

import "./BloodPanelSelectedTests.vue?vue&type=style&index=0&id=bcc2735c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcc2735c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcc2735c', __exports__)) {
    console.log('reload')
    api.reload('bcc2735c', __exports__)
  }
  
  module.hot.accept("./BloodPanelSelectedTests.vue?vue&type=template&id=bcc2735c", () => {
    console.log('re-render')
    api.rerender('bcc2735c', render)
  })

}


export default __exports__